<template>
	<div class="hospital-top">
		<div class="table-label">
			{{name}}医院销量TOP50
		</div>
		<div class="table-content" v-if="datas&&datas.length">
			<div class="content-row" v-for="(item1,index1) in datas" :key="index1">
				<div class="row-item"
					:style="{width:item.width,flex:item.width==='flex'?'1':'none',background:item.width==='flex'?'#DBE7FF':''}"
					v-for="(item,index) in titles" :key="'row0'+index">
					<img v-if="(index1===0||index1===1||index1===2)&&index==0" class="top-image"
						:src="require(`@/assets/icon/top-${index1+1}.png`)" />
					<template v-else>
						<el-tooltip v-if="item.key === 'TerminalHPName'" class="item" effect="dark" :content="item1[item.key]" placement="top-start" :disabled="isTooltipDisabled">
							<span class="name-span" @mouseenter="checkOverflow($event)">{{item1[item.key]}}</span>
						</el-tooltip>
						<template v-else>{{item1[item.key]}}</template>
					</template>
				</div>
			</div>
		</div>
		<div class="table-null" v-else>
			暂无数据
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			datas: {
				type: Array,
				default: []
			},
			name: {
				type: String,
				default: ""
			}
		},
		data() {
			return {
				isTooltipDisabled: true,
				titles: [{
					"label": '排行',
					"key": 'TOPNum',
					"width": "20px"
				}, {
					"label": '医院名称',
					"key": 'TerminalHPName',
					"width": "flex"
				}, {
					"label": '销量',
					"key": 'MoneyString',
					"width": "100px"
				}]
			}
		},
		methods: {
			checkOverflow(event) {
				const target = event.target;
				if (target.scrollWidth > target.clientWidth) {
					this.isTooltipDisabled = false;
				} else {
					this.isTooltipDisabled = true;
				}
			}
		}
	}
</script>

<style lang="less">
	.hospital-top {
		flex: 1;
		max-width: 400px;
		height: 504px;
		//background: #ffffff;
		padding: 0px 20px 0px 0px;

		.table-label {

			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #00266D;
			margin-bottom: 12px;
		}

		.table-label::before {
			content: " ";
			display: inline-block;
			width: 18px;
			height: 18px;
			transform: translateY(4px);
			background: url('../../../../../assets/report/hosp-icon.png') no-repeat;
			background-size: 100% 100%;
		}

		.table-content {
			width: 100%;
			height: 400px;
			overflow-y: auto;

			.content-row {
				display: flex;
				flex-wrap: nowrap;
				margin-bottom: 16px;

				.row-item {
					padding: 0px 12px;
					background: #FFFFFF;
					height: 26px;
					line-height: 26px;
					white-space: nowrap;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 500;
					color: #4E5969;
					display: block;
					overflow: hidden;

					//border: 2rpx solid #E5E6EB;
					//box-sizing:;
					.top-image {
						width: 14px;
						height: 14px;
						vertical-align: middle;
						margin-top: -3px;
					}

					.name-span {
						display: block;
						overflow: hidden;
						white-space: nowrap;
					}
				}
			}
		}

		.table-null {
			height: 50px;
			line-height: 50px;
			text-align: center;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 500;
			color: #cccccc;
		}
	}
</style>